<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-forgot"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                <img src="@/assets/images/pages/forgot-password.png" alt="forgot-password" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 forgot-tabs-container">

                <div class="vx-card__title mb-3">
                  <h4 class="mb-4" v-if="expirationValue">Recuperação de senha Expirada</h4>
                  <h4 class="mb-4" v-else>Recupere a sua Senha</h4>
                  <p>Digite o seu endereço de e-mail e enviaremos instruções sobre como redefinir a senha.</p>
                </div>

                <vs-tabs>
                    <vs-tab label="Admin">

                      <div class="w-full mb-6">
                        <vs-input
                          v-validate="'required|email|min:3'"
                          data-vv-validate-on="blur"
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          label-placeholder="Email"
                          v-model="email"
                          class="w-full"
                        />
                        <span class="text-danger text-sm"> {{ errors.first('email') }} </span>
                      </div>

                      <div class="pt-5 flex flex-wrap justify-between my-5">
                        <vs-button 
                          class="w-full" 
                          :disabled="!validateForm"
                          @click="sendMail"
                        >
                          {{  !blockedTime ? 'Enviar' :  'Aguarde 10 segundos para solicitar novamente' }}
                        </vs-button>

                        <div class="mt-5">
                          <a 
                            class="w-full cursor-pointer text-inherit md:w-auto hover:text-primary"
                            @click="redirectToLogin" 
                          >
                            Voltar ao Login
                          </a>
                        </div>
                      </div>
                  </vs-tab>
                </vs-tabs>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

import { getBaseUrl } from '@/utils'
import userForgot from '@/http/requests/userForgot'

export default {
    data() {
      return {
          email: '',
          blockedTime: false,
          expirationValue: false
      }
    },
    computed: {
      validateForm() {
          return !this.errors.any() && this.email !== '' && this.password !== '' && !this.blockedTime;
      },
      baseUrl() {
          return `${getBaseUrl()}`
      }
    },
    methods: {
      redirectToLogin() {
        this.$emit('emailProcessed', true);
        this.$router.push({ name: 'login' })
      },
      sendMail(){
        userForgot.create({url: this.baseUrl, email: this.email})
          .then(() => {
            this.setTime();
            this.scheduled()
            localStorage.setItem('expiration', false);
            this.expiration = false
          })
          .catch((error) => {
            console.log(error)
          })
      },
      scheduled() {
        this.$vs.notify({
          time: 6500,
          color: 'success',
          title: 'Esquecimento de Senha',
          text: `A redefinição de senha foi encaminhado com sucesso para o seu E-mail! Confira em instantes a caixa de entrada.`
        })
      },
      setTime(){
        if (!this.blockedTime){
          this.blockedTime = true;
          setTimeout(() => { this.blockedTime = false; }, 10000);
        }
      },
    },
    created(){
        this.email = localStorage.getItem('email');
        const expiration = localStorage.getItem('expiration');
        if(this.validateForm && expiration === 'true'){
          this.expirationValue = true
          this.sendMail()
        }
    }
}
</script>

<style lang="scss">
.forgot-tabs-container {
    min-height: 505px;

    .con-tab {
        padding-bottom: 14px;
    }

    .con-slot-tabs {
        margin-top: 1rem;
    }
}
</style>

